import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";

export default function ForexBrokerageLicenseCyprus (){

    return (
        <main className='main'>

            <IntroSection
                title="Forex & Brokerage License – Cyprus (CySEC / CIF)"
                subtitle="Launch Your Brokerage with EU Passporting Rights"
                description =
                    "
                        Cyprus is the <b>most popular EU jurisdiction for forex and CFD brokers</b>, regulated by the <b>Cyprus Securities and Exchange Commission (CySEC)</b>. With a <b>Cyprus Investment Firm (CIF) License</b>, your brokerage gains <b>EU-wide recognition under MiFID II</b>, allowing you to operate across the <b>European Economic Area (EEA)</b>.
                    "
                badges={
                    [
                        "Forex & CFD Brokers",
                        "Investment Dealers",
                        "Portfolio Management",
                        "Prop Trading Firms"
                    ]
                }
                buttonText="Request a Cyprus Brokerage Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/forex-brokerage-license-cyprus-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Cyprus for Brokerage?'
                        subtitle='Operating a brokerage without a license limits your growth and credibility. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "EU & Global Recognition",
                                            text: "CySEC is one of the world’s most respected regulators for forex."
                                        },
                                        {
                                            title: "MiFID II Passporting",
                                            text: "Serve clients across all EEA countries with a single license."
                                        },
                                        {
                                            title: "Lower Costs vs Malta",
                                            text: "Achieve EU-level credibility at a lower setup and operational cost."
                                        },
                                        {
                                            title: "Liquidity & PSP Access",
                                            text: "Widely accepted by Tier-1 liquidity providers, banks, and EMIs."
                                        },
                                        {
                                            title: "Forex Hub",
                                            text: "Hundreds of leading brokers are registered in Cyprus."
                                        },
                                        {
                                            title: "Scalable",
                                            text: "Start as execution-only and upgrade to market-making operations as business grows."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Brokerage Licenses (CIF Categories)"
                        subtitle='CySEC issues CIF (Cyprus Investment Firm) Licenses, with different levels of activity:'
                        blocks={[
                            {
                                title: "Execution-Only Broker (STP/ECN)",
                                items:
                                    [
                                        { text: "Execute client orders." },
                                        { text: "Cannot hold client money directly." },
                                        { text: "Capital Requirement: €150,000." }
                                    ]
                            },
                            {
                                title: "Advisory / Tied Agent",
                                items:
                                    [
                                        { text: "Provide investment advice." },
                                        { text: "Cannot hold client money or execute trades." },
                                        { text: "Capital Requirement: €75,000." }
                                    ]
                            },
                            {
                                title: "Market Maker / Dealing on Own Account",
                                items:
                                    [
                                        { text: "Provide full brokerage services (STP + market making)." },
                                        { text: "Cannot hold client money & assets." },
                                        { text: "Capital Requirement: €750,000." }
                                    ]
                            },
                        ]}
                    />

                    <LocationTimeline
                        title="Benefits of a Cyprus Brokerage License"
                        item={
                            [
                                {
                                    title: "EU Passporting",
                                    text: "Operate freely in 30+ EEA countries."
                                },
                                {
                                    title: "Top-Tier Credibility",
                                    text: "CySEC brokers are trusted by investors and PSPs."
                                },
                                {
                                    title: "Easier Access to Banks & Liquidity Providers",
                                    text: "Facilitates smooth onboarding with banks and liquidity sources."
                                },
                                {
                                    title: "Global Expansion",
                                    text: "CySEC brokers can serve clients in Asia, MENA, Africa, and LatAm."
                                },
                                {
                                    title: "Valuation Boost",
                                    text: "Licensed firms attract more investors and potential buyers."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Licensing Process'
                        features={
                            [
                                {
                                    title: "Pre-Application Consultation",
                                    text: "Select CIF category based on business model: advisory, STP, or market maker."
                                },
                                {
                                    title: "Company Incorporation",
                                    text: "Establish a legal entity in Cyprus for licensing purposes."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Submit business plan, governance documents, and AML/KYC policies."
                                },
                                {
                                    title: "CySEC Review & Interviews",
                                    text: "Regulator evaluates shareholders, directors, and risk management policies."
                                },
                                {
                                    title: "License Approval",
                                    text: "License is typically approved within 6–9 months."
                                },
                                {
                                    title: "Operational Setup",
                                    text: "Set up liquidity, trading platforms, and compliance systems to start operations."
                                }
                            ]
                        }
                    />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "6–9 months",
                            },
                            {
                                name: "Setup Costs",
                                description: "from €60,000+ (legal, compliance, advisory)",
                            },
                            {
                                name: "Capital Requirement",
                                description: "€75,000–€750,000 depending on license type",
                            },
                            {
                                name: "Annual Costs",
                                description: "audits, CySEC fees, compliance staff.",
                            },

                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Specialists in CIF licensing under CySEC." },
                                { text: "End-to-end services: incorporation, license filing, compliance manuals." },
                                { text: "Introductions to Tier-1 liquidity providers, PSPs, and banks." },
                                { text: "Comparison guidance: Cyprus vs Malta vs Offshore options." },
                                { text: "Ongoing support: compliance reporting & audits." }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                                Looking to launch a forex or CFD brokerage with EU recognition?
                             "
                         description=
                             "
                                Cyprus offers <b>CIF licenses under CySEC</b> with <b>MiFID II passporting rights</b>, making it the <b>top hub for EU forex brokers</b>.
                             "
                         buttonText='Book a Cyprus Brokerage License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Why is Cyprus popular for forex brokers?",
        content: [
            { type: "answer", text: "Lower capital requirements than Malta, full EU recognition, and strong PSP access." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–9 months, depending on complexity." },
        ],
    },
    {
        question: "What capital is required?",
        content: [
            { type: "answer", text: "€75,000 (advisory), €150,000 (STP), €750,000 (market maker)." },
        ],
    },
    {
        question: "Can I offer CFDs and derivatives?",
        content: [
            { type: "answer", text: "Yes — CySEC allows forex, CFDs, indices, commodities, and crypto CFDs." },
        ],
    },
    {
        question: "Do I need local directors?",
        content: [
            { type: "answer", text: "Yes — at least 2 Cypriot resident directors with experience in finance." },
        ],
    },
];

const testimonialsData =
    [
        {
            quote: "We licensed our forex brokerage in Cyprus with Offshore Advisory. Now we operate across the EU and beyond.",
            author: "Daniel P.",
            role: "Broker CEO"
        },
        {
            quote: "CySEC approval gave our brokerage credibility with PSPs and liquidity providers. Offshore Advisory managed the process smoothly.",
            author: "Sofia L.",
            role: "Investment Firm COO"
        }
    ]
;